import type { TransferReceiptTranslations } from "../interfaces/transferReceipt";

export const transferReceiptTranslations: TransferReceiptTranslations = {
  title: "Comprobante de transferencia",
  status_settled: "Pago exitoso",
  status_pending: "En proceso",
  status_rejected: "No se completó",
  notice_pending: "El pago sigue en proceso: este comprobante todavía no confirma que el dinero llegó.",
  notice_rejected: "El pago no se completó y el dinero volvió a la billetera.",
  amount_settled: "Valor enviado",
  amount_pending: "Valor en camino",
  amount_rejected: "Valor no enviado",
  via: "Vía",
  number: "Número de comprobante",
  network_reference: "ID de transacción Bre-B",
  to: "Para",
  from: "De",
  name: "Nombre",
  entity: "Entidad",
  reference: "Referencia",
  hash: "Hash de la transacción",
  network: "Red",
  document: "Documento",
  account: "Cuenta",
  account_value: "Billetera {{currency}}",
  sent_through: "Enviado a través de",
  sender_entity: "ColocaPayments SAS",
  footer: "Comprobante generado por Coloca Payments",
  file_prefix: "comprobante-coloca",
  share_text: "Te envié {{amount}} con Coloca.",
  destination_breb_key: "Llave",
  destination_pix_key: "Llave PIX",
  destination_bank_account: "Cuenta",
  destination_clabe: "CLABE",
  destination_cbu_cvu: "CBU/CVU",
  destination_crypto_wallet: "Billetera",
  savings_account: "Cuenta de ahorros",
  checking_account: "Cuenta corriente",
  alias: "Alias",
  view: "Ver comprobante",
  share_image: "Compartir imagen",
  share_pdf: "Compartir PDF",
  download_image: "Descargar imagen",
  download_pdf: "Descargar PDF",
  failed: "No pudimos generar el comprobante. Intenta de nuevo.",
};
